// extracted by mini-css-extract-plugin
export default {"hero":"YAqN2U1i","backgroundImage":"PFobRdsS","content":"yVVjhBNK","textContent":"cFQmfobl","heading":"wILDF4wo","textBlock":"Jlz_qxZS","button":"Xq6CEd8l"};